import React                      from 'react'
import { Observer }               from 'mobx-react'
import { Button
       , Icon
       , Upload }                 from 'antd'

import { TEXT
       , tr }                     from '../00_assets'
import { CTE }                    from '../01_core'
// import { kde_api_client_t }       from '../02_api'
import { MApp }                   from '../09_model_app'
import { FIELD_TYPE
       , FormError
       , FormField
       , form_model
       , IFormEditor
       , IFormEditorModel
       , SelectMKSType
       , SelectKeyApp
       , SelectClient
       , SelectDataSheet
       , VALID }                  from '../10_ui'


export function create_mastering_editor_model ( )
{
  const fields =
    { name     : { label: TEXT.KEY_MASTERING_NAME
                 , init: ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , model    : { label: TEXT.KEY_MODEL
                 , init: ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , mks_type : { label: TEXT.UI_MKS_TYPE
                 , init: CTE.ENUM_NON_SELECTED
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_enum
                 , required: true
                 }
    , client   : { label: TEXT.UI_CLIENT
                 , init: '' // CTE.ENUM_NON_SELECTED
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: ( a: any ) => a !== ''? 0 : 1 // VALID.non_empty_enum
                 , required: true
                 }
    , file     : { label: TEXT.UI_FILE
                 , init: undefined
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: ( v: any ) => v === undefined? 1 : 0
                 , required: true
                 }
    , key_app  : { label: TEXT.UI_KEY_APP
                 , init: CTE.ENUM_NON_SELECTED
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_enum
                 , required: true
                 }
    , data_sheet: { label: TEXT.KEY_DATA_SHEET
                 , init: ''
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_txt
                 , required: false
                 }
  }

    return form_model( fields
                   , ( data: IFormEditorModel ) =>
                   {
                      const user = MApp( ).user
                          , is_keso = data.mks_type.value( ) === 0 ;

                      if(is_keso){
                          return { keyApplicationId: data.key_app.value( )
                                , model: data.model.value( )
                                , file: data.file.value( )
                                , typeId: data.mks_type.value( )
                                , name: data.name.value( )
                                , clientId: parseInt( data.client.value( ), 10 )
                                , workgroupId: user? user!.workgroup.id : 0
                                } ;
                      } else {
                        return { keyApplicationId: data.key_app.value( )
                              , datasheetId: data.data_sheet.value( )
                              , model: data.model.value( )
                              , file: data.file.value( )
                              , typeId: data.mks_type.value( )
                              , name: data.name.value( )
                              , clientId: parseInt( data.client.value( ), 10 )
                              , workgroupId: user? user!.workgroup.id : 0
                              } ;
                      }
                   } ) ;
}


export const MasteringEditor: React.FC< { form: IFormEditor } > = ({ form }) =>
<Observer render={ ( ) => 
{ 
  const do_nothing = ( ev: React.FormEvent<HTMLFormElement> ) =>
     {
       ev.preventDefault( ) ;
       ev.stopPropagation( ) ;
     } ;

  return <form onSubmit={ do_nothing }>
          <FormField field={ form.model.name    } />
          <FormField field={ form.model.mks_type }>
              <SelectMKSType
                className="w-100"
                { ...form.model.mks_type.bind( ) }
              />
          </FormField>

          { form.model.mks_type.value( ) === 1?
            <FormField field={ form.model.data_sheet }>
              <SelectDataSheet {...form.model.data_sheet.bind( )} />
            </FormField>
          : null }

          <FormField field={ form.model.model   } />


         <FormField field={ form.model.key_app }>
            <SelectKeyApp
               className="w-100"
               { ...form.model.key_app.bind( ) }
            />
         </FormField>

         <FormField field={ form.model.client }>
            <SelectClient
              className="w-100"
              onSelect={ form.model.client.bind( ).onChange }
            />
         </FormField>

         <FormField field={ form.model.file }>
            <Upload 
              beforeUpload={ ( file: any ) =>
                {
                  form.model.file.bind( ).onChange( file ) ;

                  return false ;
                } }
              fileList={ form.model.file.value( )? [ form.model.file.value( ) ] : [] }
              accept=".dat,.xml"
            >
              <Button>
                <Icon type="upload" /> { tr( TEXT.UI_SELECT_FILE ) }
              </Button>
            </Upload>
         </FormField>
         <FormError has={ form.show_error( ) } />

     </form> ;
} } /> ;
